export enum actionTypes {
    SET_JACKPOTS = 'JACKPOTS:SET'
}
